import { CaseLenderStateEnum } from "@src/apis/ModularClient";

export const getStatusTextForLender = (caseLenderState: CaseLenderStateEnum, IsBidAccepted: boolean): string => {
  let statusText = "";

  switch (caseLenderState) {
    case CaseLenderStateEnum.Offered:
    case CaseLenderStateEnum.SentToPackager: {
      statusText = IsBidAccepted ? "DIP submitted and accepted" : "DIP submitted";
      break;
    }
    case CaseLenderStateEnum.Received: {
      statusText = "Case to review";
      break;
    }
    case CaseLenderStateEnum.Rejected: {
      statusText = "Case rejected";
      break;
    }
    case CaseLenderStateEnum.Withdrawn: {
      statusText = "DIP withdrawn";
      break;
    }
    case CaseLenderStateEnum.Cancelled: {
      statusText = "Application cancelled";
      break;
    }
    case CaseLenderStateEnum.Applied: {
      statusText = "DIP submitted and accepted";
      break;
    }
  }

  return statusText;
};

const CaseLenderHelper = {
  getStatusTextForLender,
};

export default CaseLenderHelper;
